const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* ─────────────────────────────────────────────────────────────
   LUVIA · פיצול באנדל לפריטים נפרדים
   תבנית בדיקה בלבד — לא מפורסמת.
   הבאנדל נכנס לעגלה כמוצרים האמיתיים שלו, לא כווריאנט אחד.
   העגלה נפתחת כמגירה, והאפסייל נשאר כמו בלייב.
   ───────────────────────────────────────────────────────────── */
(function () {
  var MAT   = 46953154969798;  /* משטח רחצה           · 189 */
  var BRUSH = 46973415424198;  /* מברשת רחצה סיליקון  ·  59 */
  var BALLS = 46950927302854;  /* כדורים מסירי שיער   ·  49 */

  var SPLIT = {};
  SPLIT[46953155002566] = [
    { id: MAT,   quantity: 1 },
    { id: BRUSH, quantity: 1 }
  ];
  SPLIT[46953155035334] = [
    { id: MAT,   quantity: 1 },
    { id: BRUSH, quantity: 1 },
    { id: BALLS, quantity: 1 }
  ];

  /* נעילה: מונעת הוספה כפולה כששני מאזינים נורים על אותה לחיצה */
  var adding = false;

  function chosenItems() {
    var card = document.querySelector('.luv-bundle .luv-c.on');
    if (card) {
      var byCard = SPLIT[Number(card.getAttribute('data-id'))];
      if (byCard) return byCard;
    }
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input ? SPLIT[Number(input.value)] || null : null;
  }

  function swap(html, freshSel, curSel) {
    if (!html) return false;
    try {
      var doc   = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector(freshSel);
      var cur   = document.querySelector(curSel);
      if (fresh && cur) { cur.innerHTML = fresh.innerHTML; return true; }
    } catch (err) {}
    return false;
  }

  function renderSections(sections) {
    if (!sections) return false;
    var ok = swap(sections['cart-drawer'], 'cart-drawer .drawer__inner', 'cart-drawer .drawer__inner');
    if (!ok) { ok = swap(sections['cart-drawer'], '.drawer__inner', 'cart-drawer .drawer__inner'); }
    swap(sections['cart-icon-bubble'], '.shopify-section', '#cart-icon-bubble');
    return ok;
  }

  function openDrawer() {
    var d = document.querySelector('cart-drawer');
    if (!d) return false;
    d.classList.remove('is-empty');
    if (typeof d.open === 'function') {
      try { d.open(); return true; } catch (err) {}
    }
    d.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
    return true;
  }

  function nudgeUpsell() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    var tries = 0;
    var t = setInterval(function () {
      if (document.querySelector('[data-luv-up]') || ++tries > 12) { clearInterval(t); return; }
      d.classList.add('luv-nudge');
      d.classList.remove('luv-nudge');
    }, 250);
  }

  function addSplit(e, btn) {
    var items = chosenItems();
    if (!items) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (adding) return;   /* כבר בתהליך — מתעלמים מהירייה השנייה */
    adding = true;

    var span  = btn ? btn.querySelector('span') : null;
    var label = span ? span.textContent : '';
    if (btn)  { btn.disabled = true; }
    if (span) { span.textContent = 'מוסיף…'; }

    function done() {
      adding = false;
      if (btn)  { btn.disabled = false; }
      if (span) { span.textContent = label; }
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) { done(); return; }
        renderSections(data && data.sections);
        if (!openDrawer()) { window.location.href = '/cart'; return; }
        nudgeUpsell();
        done();
      })
      .catch(function () { done(); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest
      ? e.target.closest('form[action*="/cart/add"] button[name="add"]')
      : null;
    if (btn) { addSplit(e, btn); }
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && f.action.indexOf('/cart/add') > -1) { addSplit(e, null); }
  }, true);
})();

/* ─────────────────────────────────────────────────────────────
   LUVIA · האפסייל לא מציע מה שכבר בעגלה
   קנו משטח + מברשת רחצה — המברשת יורדת מרשימת האפסייל,
   ונשארות רק ההצעות שעוד לא נלקחו.
   ───────────────────────────────────────────────────────────── */
(function () {
  var inCart = [];

  function apply() {
    var box = document.querySelector('[data-luv-up]');
    if (!box) return;
    var shown = 0;
    box.querySelectorAll('[data-luv-add]').forEach(function (btn) {
      var row = (btn.closest && btn.closest('.luv-up__row')) || btn.parentNode;
      if (!row) return;
      var taken = inCart.indexOf(Number(btn.getAttribute('data-luv-add'))) > -1;
      row.style.display = taken ? 'none' : '';
      if (!taken) { shown++; }
    });
    /* כל ההצעות כבר בעגלה — מסתירים את הבלוק כולו */
    box.style.display = shown ? '' : 'none';
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        inCart = (c.items || []).map(function (i) { return Number(i.variant_id); });
        apply();
      })
      .catch(function () {});
  }

  function watch() {
    var d = document.querySelector('cart-drawer, #CartDrawer');
    if (!d) { setTimeout(watch, 500); return; }
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(apply, 80);
    }).observe(d, { childList: true, subtree: true });
    refresh();
  }

  var nf = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nf.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refresh, 300); }).catch(function () {});
    }
    return p;
  };

  if (document.readyState !== 'loading') { watch(); }
  else { document.addEventListener('DOMContentLoaded', watch); }
})();